import { ReactNode } from 'react';
import { AgreementFooter, AgreementHeader, AgreementWrapper } from './styles';
import { COLORS } from '@/styles/colors';
import { Typography } from '@/components/Typography/Typography';
import { Box } from '@/components/Box/Box';

type MasterServiceAgreementWidgetType = {
  header: string;
  modifiedDate: string;
  children: ReactNode;
  actionSlot: ReactNode;
};

export const MasterServiceAgreementWidget = ({
  header,
  modifiedDate,
  children,
  actionSlot,
}: MasterServiceAgreementWidgetType) => {
  return (
    <AgreementWrapper>
      <AgreementHeader>
        <Typography variant='subTitleSmall' color={COLORS.grey[900]} fontWeight='semibold' wordBreak='break-word'>
          {header}
        </Typography>
        <Typography color={COLORS.grey[400]} fontWeight='medium' flexShrink={0}>
          Last modified: {modifiedDate}
        </Typography>
      </AgreementHeader>
      <Box display='flex' flexDirection='column' flexGrow='1' overflow='auto' mobile={{ minHeight: '350px' }}>
        <Box display='flex' flexDirection='column' padding='20px 42px' mobile={{ padding: '20px 16px' }}>
          {children}
        </Box>
      </Box>
      <AgreementFooter>{actionSlot}</AgreementFooter>
    </AgreementWrapper>
  );
};
